import { Component, OnInit } from '@angular/core';
import { CalendarEvent, CalendarView } from 'angular-calendar';
import { CalendarUtilsService } from 'src/app/services/calendar-utils.service';
import { Constants } from 'src/app/constants/constants';
import { NotificationService } from 'src/app/services/notification.service';
import { Subscription, timer } from 'rxjs';
import { AgendaToggleService } from 'src/app/services/agenda-toggle.service';
import { EventsService } from 'src/app/services/events.service';
import { addWeeks } from 'date-fns';
import * as moment from 'moment';
import { ComponentsCommunicationService } from 'src/app/services/components-communication.service';

@Component({
  selector: 'transflo-layout-control-calendar',
  templateUrl: './layout-control-calendar.component.html',
})

export class LayoutControlCalendarComponent implements OnInit {
  flagIsActive = false;
  view = CalendarView.Month;
  calendarView = Constants.week;
  viewDateCalendar: Date = new Date();
  selectedDate: Date;
  events: CalendarEvent[];

  public notificationLabel: string;
  public notificationClass: string;
  public showloader = false;
  public source = timer(5000);
  private refreshSubscription: Subscription;

  constructor(
    private calendarUtils: CalendarUtilsService,
    private notificationService: NotificationService,
    private agendaToggleService: AgendaToggleService,
    private eventsService: EventsService,
    private communicationService: ComponentsCommunicationService
  ) { }

  ngOnInit(): void {
    this.refreshSubscription = this.communicationService.refresh$.subscribe(() => {
      this.refreshCalendar();
    });

    this.refreshCalendar();
  }

  refreshCalendar(): void {
    this.notificationService.notificationSubject
      .subscribe(value => {
        this.notificationLabel = value.eventAddedNotificationLabel;
        this.notificationClass = value.eventAddedNotificationClass;
        this.showloader = true;
        this.source.subscribe(val => {
          this.showloader = false;
        });
      });

    this.agendaToggleService.isFlaggedAgenda
      .subscribe(value => {
        this.flagIsActive = value;
      });

    this.agendaToggleService.calendarInitSubject
      .subscribe(value => {
        this.viewDateCalendar = value;
      });

    const monthEndWeek = addWeeks(this.viewDateCalendar, 3);
    this.eventsService.getCalendarDays({
      fromDate: moment(this.viewDateCalendar).diff(moment(), 'days') === 0 ? moment(this.viewDateCalendar).format('YYYY-MM-DD') :
        moment(this.viewDateCalendar).diff(moment(), 'days') < 0 ? moment().format('YYYY-MM-DD') :
          moment(this.viewDateCalendar).startOf('week').format('YYYY-MM-DD'),
      toDate: moment(this.calendarView === 'week' ? this.viewDateCalendar : monthEndWeek).diff(moment(), 'days') <= 0 ?
        moment().endOf('week').format('YYYY-MM-DD') : moment(this.calendarView === 'week' ? this.viewDateCalendar : monthEndWeek)
          .endOf('week').format('YYYY-MM-DD')
    }).subscribe(value => {
      this.constructEventsArray(value.body);
    });

    this.calendarUtils.calendarDaysSubject.subscribe(result => {
      const monthsEndWeek = addWeeks(this.viewDateCalendar, 3);
      this.eventsService.getCalendarDays({
        fromDate: moment(this.viewDateCalendar).diff(moment(), 'days') === 0 ? moment(this.viewDateCalendar).format('YYYY-MM-DD') :
          moment(this.viewDateCalendar).diff(moment(), 'days') < 0 ? moment().format('YYYY-MM-DD') :
            moment(this.viewDateCalendar).startOf('week').format('YYYY-MM-DD'),
        toDate: moment(this.calendarView === 'week' ? this.viewDateCalendar : monthsEndWeek).diff(moment(), 'days') <= 0 ?
          moment().endOf('week').format('YYYY-MM-DD') : moment(this.calendarView === 'week' ? this.viewDateCalendar : monthsEndWeek)
            .endOf('week').format('YYYY-MM-DD')
      }).subscribe(value => {
        this.constructEventsArray(value.body);
      });
    });
  }
  constructEventsArray(arr: any): void {
    if (arr) {
      this.events = arr.filter((el: any) => {
        return el.HasEvent || el.HasFlaggedEvent;
      }).map((event: any) => ({
        start: event.HasEvent || event.HasFlaggedEvent ? new Date(event.CalendarDate) : '',
        end: event.HasEvent || event.HasFlaggedEvent ? new Date(event.CalendarDate) : '',
        cssClass: event.HasFlaggedEvent ? 'flaggedCalEvent' : ''
      }));
    }
  }

  increment(dateViewType: string): void {
    this.changeDate(this.calendarUtils.addPeriod(Constants.week,
      this.viewDateCalendar, dateViewType === Constants.month ? 4 : 1));
  }

  decrement(dateViewType: string): void {
    this.changeDate(this.calendarUtils.subPeriod(Constants.week,
      this.viewDateCalendar, dateViewType === Constants.month ? 4 : 1));
  }

  changeDate(date: Date): void {
    this.viewDateCalendar = date;
    this.selectedDate = date;
    this.calendarUtils.calendarDaysSubject.next(true);
    this.calendarUtils.calendarChangeEvents.next(date);
  }

  toggleCalendarView(): void {
    this.calendarView = this.calendarView === Constants.month ? Constants.week : Constants.month;
    this.calendarUtils.calendarViewSubject.next(this.calendarView);
    this.calendarUtils.calendarDaysSubject.next(true);
  }

  dayClicked(dayDate: any) {
    this.selectedDate = dayDate;
    this.calendarUtils.calendarDayClicked.next(dayDate);
  }

}
